import * as React from "react";
import {
  Checkbox,
  TextField,
  Autocomplete,
  Chip,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { CheckBoxOutlineBlank, CheckBox, Queue } from "@mui/icons-material";
import styles from "../module_css/formsCatalogs.module.css";
import imgAsign from "../assets/svg/asign.svg";
import Swal from "sweetalert2";
import ApiController from "../controllers/api";
import CustomBackdrop from "./CustomBackdrop";

export default function AsignSafeGaurds({ 
  handleClose, 
  refreshData
  }) {
  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL), []);
  const getConstants = async () => await apiInstance.get(`/safe-guard/constants/asign/`);
  const getInventoryByArea = async (value) => await apiInstance.get(`/safe-guard/constants/inventory/?AREA=${value}`);
  const CreateData = async (data) => await apiInstance.post("/safe-guard/", data);

  const [selected, setSelected] = React.useState([]);
  const [getData, setGetData] = React.useState([]);
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [asignData, setAsignData] = React.useState([]);
  const [data, setData] = React.useState({
    area: "",
    asignDatas: [],
  });

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "area" && value) {
      setSelected([]); //REINICIAR LOS CHIPS
      setOpenBackdrop(true);
      const res = await getInventoryByArea(value);

      if (res.success && res.count > 0) {
        setAsignData(res.data);
      } else if (res.success && res.count === 0){
        Swal.fire({
            title: 'LOS BIENES YA SE ENCUENTRAN EN RESGUARDO',
            icon: 'warning',
            text: 'NO SE ENCONTRARON BIENES QUE SE ENCUENTREN SIN RESGUARDO',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor:'#f8bb86',
            confirmButtonText: 'CONFIRMAR'
        });
        setAsignData([]);
      } else {
        Swal.fire({
            title: '¡ERROR! ❌',
            icon: 'error',
            text: 'NO SE PUDIERON CARGAR LOS DATOS',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor:'#ef7474',
            confirmButtonText: 'CONFIRMAR',
            padding: '0 0 20px'
          });
        setAsignData([]);
        handleClose();
      }
      setOpenBackdrop(false);
    }
  };
  React.useEffect(() => {
    (async () => {
      setOpenBackdrop(true);
      const res = await getConstants();
      if (res.success) {
        setGetData(res.data);
      } else if (!res.success) {
        Swal.fire({
          title: "¡ERROR! ❌",
          icon: "error",
          text: "NO SE PUDIERON CARGAR LOS DATOS",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor: "#ef7474",
          confirmButtonText: "CONFIRMAR",
          padding: "0 0 20px",
        });
        handleClose();
      }
      setOpenBackdrop(false);
    })();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    Swal.fire({
      title: "ASIGNAR BIENES",
      text: "¿ESTAS SEGURO DE QUERER ASIGNAR ESTOS BIENES?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SI, ASIGNAR",
      confirmButtonColor: "#397e32",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenBackdrop(true);
        const payload = {
          AREA: data.area,
          INVENTORY_AREA: selected.map((item) => item.ID),
        };
        const res = await CreateData(payload);
        if (res.success) {
          Swal.mixin({
            toast: true,
            position: "bottom-start",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          }).fire({
            icon: "success",
            title: "VALE DE RESGUARDO",
            text: "EL VALE DE RESGUARDO SE CREO CORRECTAMENTE",
          });
          handleClose();
          if (refreshData) refreshData();
        } else {
          Swal.fire({
            title: "¡ERROR! ❌",
            icon: "error",
            text: "NO SE PUDO CREAR EL VALE DE RESGUARDO",
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#ef7474",
            confirmButtonText: "CONFIRMAR",
            padding: "0 0 20px",
          });
        }
        setOpenBackdrop(false);
        handleClose();
      }else if(result.isDenied || result.isDismissed){
        setOpenBackdrop(false);
      }
    });
  };

  const derivedOptions = React.useMemo(() => {
    if (!asignData || asignData.length === 0) return [];
    return [{ __select_all: true, CODIGO: 'ASIGNAR TODOS LOS BIENES' }, ...asignData];
  }, [asignData]);

  // Íconos para el checkbox
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;
  return (
    <>
      <CustomBackdrop open={openBackdrop} />
      <Box className={styles.container_main_form} onSubmit={handleSubmit}>
        <img src={imgAsign} alt="Logo" className={styles.logo_form} />
        <Typography variant="h6" gutterBottom>
          ASIGNACIÓN DE BIENES
        </Typography>

        <FormControl variant="outlined" sx={{ mt: 1, mb: 2 }} fullWidth>
          <InputLabel id="area-label">AREA DESIGNAR</InputLabel>
          <Select
            labelId="area-label"
            id="area-select"
            name="area"
            value={data.area}
            onChange={handleChange}
            label="AREA A ASIGNAR"
          >
            {(getData.AREAS || []).map((sj) => (
              <MenuItem key={sj.UUID} value={sj.VALUE}>
                {sj.NOMBRE}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Autocomplete
          PopperProps={{ placement: 'bottom-start' }}
          disabled={asignData.length === 0}
          multiple
          disableCloseOnSelect
          noOptionsText="NO HAY BIENES DISPONIBLES"
          id="asign"
          options={derivedOptions}
          value={selected}
          getOptionLabel={(option) => option.CODIGO}
          onChange={(event, newValue) => {
            const hasSelectAll = Array.isArray(newValue) && newValue.some(o => o && o.__select_all);
            if (hasSelectAll) {
              if (selected.length === asignData.length) setSelected([]);
              else setSelected(Array.from(asignData));
            } else {
              setSelected(newValue);
            }
          }}
          renderOption={(props, option, { selected: optionSelected }) => {
            if (option && option.__select_all) {
              const allSelected = asignData && asignData.length > 0 && selected.length === asignData.length;
              return (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={allSelected}
                  />
                  {option.CODIGO}
                </li>
              );
            }
            return (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={optionSelected}
                />
                {option.CODIGO}
              </li>
            );
          }}
          renderTags={(value, getTagProps) => (
            <div style={{ maxHeight: 96, overflowY: 'auto', display: 'flex', flexWrap: 'wrap', gap: 6, padding: '4px 2px' }}>
              {value.filter(v => !(v && v.__select_all)).map((option, index) => (
                <Chip
                  key={option.ID || option.CODIGO || index}
                  label={option.CODIGO}
                  size="small"
                  {...getTagProps({ index })}
                />
              ))}
            </div>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="SELECCIONA LOS BIENES A ASIGNAR"
              placeholder="ASIGNAR BIENES"
            />
          )}
          fullWidth
        />

        {selected.length > 0 && (
          <Typography variant="caption" sx={{ mt: 2, mb: 2, fontWeight: 'bold', color: '#397e32' }}>
           CANTIDAD DE BIENES ASIGNADOS: {selected.length}
          </Typography>
        )}

        <Button
          variant="contained"
          color="success"
          sx={{ mt: 2 }}
          onClick={handleSubmit}
          disabled={selected.length === 0}
          startIcon={<Queue />}
          type="submit"
          fullWidth
        >
          ASIGNAR RESGUARDOS
        </Button>
      </Box>
    </>
  );
}
